import './design/ripple.js';
import './design/menu.js';
import './design/dialog.js';
import './design/tabs.js';
import './design/snackbar.js';
import './design/progress.js';
import './design/slider.js';
import './design/chips.js';
import './design/drawer.js';
import './design/select.js';
import './design/alert.js';
import './design/pagination.js';
import './design/table-sort.js';
import './design/banner.js';
import './design/appbar.js';
import './design/bottom-sheet.js';
import './design/dropzone.js';
import './design/toast.js';
import './design/popover.js';
import './design/textarea.js';
import './design/theme.js';
import './design/overlay.js';
import './design/form-validate.js';
import './design/avatar.js';
import './design/empty.js';
import './design/stepper.js';
import './design/carousel.js';
import './design/rating.js';
import './design/date-picker.js';
import './design/time-picker.js';
import './design/autocomplete.js';
import './design/tag-input';
import './design/fab-dial';
import './design/nav-rail';
import './design/color-picker';
import './design/tree';
import './design/range-dual';
import './design/table-select';
import './design/appbar-search';

// ✅ Page Builder
import {initBuilder} from './builder.js';

console.log('JS Ready');

/* ---------------------------
   reCAPTCHA v3 (comment form)
   - v3 n'affiche pas de case à cocher
   - on génère un token au moment du submit
---------------------------- */
function getMetaContent(name) {
    const meta = document.querySelector(`meta[name="${name}"]`);
    return meta ? meta.getAttribute('content') || '' : '';
}

function attachCommentRecaptchaV3() {
    const form = document.querySelector('form[action="/comment"]');
    if (!form) return;

    const siteKey = getMetaContent('recaptcha-site-key');
    if (!siteKey) return; // reCAPTCHA non configuré (clé absente)

    const tokenInput = form.querySelector('#comment-recaptcha-token');
    if (!tokenInput) return;

    // Intercepter le submit pour injecter un token v3 valide
    form.addEventListener('submit', (e) => {
        // Si reCAPTCHA n'est pas chargé (adblock / script bloqué), on stoppe et on avertit
        if (typeof window.grecaptcha === 'undefined') {
            e.preventDefault();
            alert("reCAPTCHA n'est pas chargé. Désactive ton bloqueur de publicité ou réessaie.");
            return;
        }

        // Empêcher le submit, on génère le token puis on submit
        e.preventDefault();

        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(siteKey, {action: 'comment'})
                .then((token) => {
                    tokenInput.value = token;
                    form.submit(); // submit natif (ne relance pas l'event)
                })
                .catch(() => {
                    alert("Impossible de valider le reCAPTCHA. Réessaie.");
                });
        });
    }, {capture: true});
}

/* ---------------------------
   MODALS
---------------------------- */
document.addEventListener('DOMContentLoaded', function () {
    const openButtons = document.querySelectorAll('[data-modal-target]');
    const closeElements = document.querySelectorAll('[data-modal-close]');

    function openModal(selector) {
        const modal = document.querySelector(selector);
        if (!modal) return;
        modal.classList.add('modal--open');
        modal.setAttribute('aria-hidden', 'false');
    }

    function closeModal(modal) {
        modal.classList.remove('modal--open');
        modal.setAttribute('aria-hidden', 'true');
    }

    openButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            openModal(btn.dataset.modalTarget);
        });
    });

    closeElements.forEach((el) => {
        el.addEventListener('click', () => {
            const modal = el.closest('.modal');
            if (modal) closeModal(modal);
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            document.querySelectorAll('.modal.modal--open').forEach((m) => closeModal(m));
        }
    });

    // ✅ Init Page Builder (s’active seulement si .builder__layout existe)
    initBuilder();

    // ✅ reCAPTCHA v3 pour le commentaire (s'active uniquement si la page contient le form)
    attachCommentRecaptchaV3();
});

/* ---------------------------
   RECHERCHE + PAGINATION (5 / page)
---------------------------- */
document.addEventListener('DOMContentLoaded', () => {
    const input = document.getElementById('articleSearch');
    const clearBtn = document.getElementById('clearSearch');
    const allCards = Array.from(document.querySelectorAll('.article-card'));

    if (!input || allCards.length === 0) return;

    const PER_PAGE = 4;
    let filteredCards = [...allCards];
    let currentPage = 1;

    const normalize = (s) =>
        (s || '')
            .toString()
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

    // Message "aucun résultat"
    let noResultEl = document.getElementById('articleNoResult');
    if (!noResultEl) {
        noResultEl = document.createElement('p');
        noResultEl.id = 'articleNoResult';
        noResultEl.textContent = 'Aucune annonce ne correspond à votre recherche.';
        noResultEl.style.display = 'none';
        input.parentElement?.insertAdjacentElement('afterend', noResultEl);
    }

    // Wrap pagination
    let paginationWrap = document.getElementById('articlePaginationWrap');
    if (!paginationWrap) {
        paginationWrap = document.createElement('div');
        paginationWrap.id = 'articlePaginationWrap';
        paginationWrap.style.display = 'flex';
        paginationWrap.style.justifyContent = 'center';
        paginationWrap.style.margin = '18px 0';

        const main = input.closest('main') || document.querySelector('main');
        (main || document.body).appendChild(paginationWrap);
    }

    // ✅ IMPORTANT : PAS de data-pagination (sinon design/pagination.js peut intercepter)
    let paginationNav = document.getElementById('articlePaginationNav');
    if (!paginationNav) {
        paginationNav = document.createElement('nav');
        paginationNav.id = 'articlePaginationNav';
        paginationNav.className = 'pagination';
        paginationNav.setAttribute('aria-label', 'Pagination annonces');
        paginationWrap.appendChild(paginationNav);
    }

    function totalPages() {
        return Math.ceil(filteredCards.length / PER_PAGE);
    }

    function setPage(page) {
        const tp = totalPages();
        currentPage = Math.min(Math.max(1, page), Math.max(1, tp));
    }

    function renderCards() {
        // Cache tout (robuste)
        allCards.forEach((c) => {
            c.hidden = true;
            c.style.display = 'none';
        });

        const start = (currentPage - 1) * PER_PAGE;
        const end = start + PER_PAGE;
        const pageCards = filteredCards.slice(start, end);

        pageCards.forEach((c) => {
            c.hidden = false;
            c.style.display = '';
        });

        noResultEl.style.display = filteredCards.length === 0 ? '' : 'none';
    }

    function renderPagination() {
        const tp = totalPages();

        if (tp <= 1) {
            paginationWrap.style.display = 'none';
            paginationNav.innerHTML = '';
            return;
        }

        paginationWrap.style.display = 'flex';
        paginationNav.innerHTML = '';

        const prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'page-nav';
        prev.dataset.prev = '1';
        prev.setAttribute('aria-label', 'Précédent');
        prev.textContent = '‹';
        prev.disabled = currentPage === 1;
        paginationNav.appendChild(prev);

        for (let i = 1; i <= tp; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'page';
            b.dataset.page = String(i);
            b.textContent = String(i);
            if (i === currentPage) b.setAttribute('aria-current', 'page');
            paginationNav.appendChild(b);
        }

        const next = document.createElement('button');
        next.type = 'button';
        next.className = 'page-nav';
        next.dataset.next = '1';
        next.setAttribute('aria-label', 'Suivant');
        next.textContent = '›';
        next.disabled = currentPage === tp;
        paginationNav.appendChild(next);
    }

    function renderAll() {
        renderCards();
        renderPagination();
    }

    function applyFilter() {
        const q = normalize(input.value);
        if (clearBtn) clearBtn.hidden = q.length === 0;

        filteredCards = allCards.filter((card) => {
            const titleEl = card.querySelector('.article-title');
            const title = normalize(titleEl ? titleEl.textContent : '');
            return q === '' || title.includes(q);
        });

        currentPage = 1;
        renderAll();
    }

    // Recherche
    input.addEventListener('input', applyFilter);

    if (clearBtn) {
        clearBtn.addEventListener('click', () => {
            input.value = '';
            input.focus();
            applyFilter();
        });
    }

    input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            input.value = '';
            applyFilter();
            input.blur();
        }
    });

    // Pagination (clic)
    paginationNav.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn) return;

        e.preventDefault();

        if (btn.dataset.prev) {
            setPage(currentPage - 1);
            renderAll();
            return;
        }
        if (btn.dataset.next) {
            setPage(currentPage + 1);
            renderAll();
            return;
        }
        if (btn.dataset.page) {
            const p = Number(btn.dataset.page);
            if (!Number.isNaN(p)) {
                setPage(p);
                renderAll();
            }
        }
    });

    // Init
    applyFilter();
});
